import EventEmitter from 'events';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';

class ItemMaintenanceAStore extends EventEmitter {
    PageLoadData = "";
    updateFavPageResponse = { updateType: 0, responseStr: "" };
    handlestore = (action) => {
        switch (action.action.type) {
            case SDIConstants.methodNames.ItemMaintenanceA_PageLoad: {
                this.PageLoadData = action.action.response;
                this.emit('ItemMaintenanceAPageLoad');
                break;
            }
            case SDIConstants.methodNames.ItemMaintenanceA_SaveButtonClick: {
                this.PageLoadData = action.action.response;
                this.emit('save');
                break;
            }
            case SDIConstants.methodNames.ItemMaintenanceA_ValidateMfg: {
                this.PageLoadData = action.action.response;
                this.emit('ValidateMfg');
                break;
            }
            case "NOTIFY_InsertFavPage": {

                this.updateFavPageResponse.updateType = 1;
                this.updateFavPageResponse.responseStr = action.action.response;
                this.emit('updateFavPage');
                break;
            }
            case "NOTIFY_DeleteFavPage": {
                this.updateFavPageResponse.updateType = 2;
                this.updateFavPageResponse.responseStr = action.action.response;
                this.emit('updateFavPage');
                break;
            }
            case "NOTIFY_CurrentFavPage": {
                this.currentFavPageResponse = action.action.response;
                this.emit('favpage');
                break;
            }

        }
    }
}
/***
 * STKS_PS_02
 * */
const obj = new ItemMaintenanceAStore;
// Dispatcher code
Dispatcher.register(obj.handlestore.bind(obj));
export default obj;